import React from 'react'
import './Supportcomp.css'
const Supportcomp = ({Icon,Icondata,onClick,style
}) => {
  return (
    <div className='supportcom-icon' onClick={onClick} style={style}>
        <img src={Icon} className='image-support-div-img'/>
        <h5 className='h5-heaidng-support'>{Icondata}</h5>
        </div>
  )
}

export default Supportcomp